import TopService from "../../services/topService";
import TopUsers from "./TopUsers";

const TopUsersByQty = () => {
  const title = "Biggest collections";

  const { getTopUsersByNumber } = TopService();

  const renderValue = (value: number) => {
    return "Number of shirts: " + String(value);
  };

  return (
    <TopUsers
      getUsersCall={getTopUsersByNumber}
      title={title}
      renderValue={renderValue}
    />
  );
};

export default TopUsersByQty;
